import { DEFAULT_MAXIMUM_RETRY_DELAY } from '../../const';

/**
 * Default function for determining the retry delay based on the number of
 * attempts. It implements an exponential backoff, starting at a delay of 1s,
 * and doubling with each attempt. The delay is also capped at a maximum of 30s.
 * This mirrors the default delay used by Tanstack Query.
 */
export const defaultGetDelayFromNumberOfAttempts = ({
  numberOfFailedAttempts,
}: {
  numberOfFailedAttempts: number;
}): number =>
  numberOfFailedAttempts < 1
    ? 0
    : Math.min(
        DEFAULT_MAXIMUM_RETRY_DELAY,
        1000 * Math.pow(2, numberOfFailedAttempts - 1),
      );
